module.exports = __webpack_public_path__ + "static/img/k_e.49bf48ad.png";